import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SharedModule } from '../../shared/shared.module'
import { OldSiteRoutingModule } from './old-site-routing.module'

@NgModule({
  declarations: [],
  imports: [CommonModule, SharedModule, OldSiteRoutingModule],
  exports: [],
})
export class OldSiteModule {}
